import LessonExitLinksContainer from './container';
import LessonExitLinks, { LessonExitLinksProps } from './LessonExitLinks';

export type LessonExitLinksProps = LessonExitLinksProps;

export { LessonExitLinks };
export default LessonExitLinksContainer;
